module.exports = __webpack_public_path__ + "img/timer-white.e77a801e.svg";